import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Defs, Path, Pattern, Rect, Use, Image } from 'react-native-svg';
const beePracticeBotIcon = require('../images/beePracticeBot.png');

const BeePracticeBotsHexagon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 63}
          height={props.height ?? 60}
          viewBox="0 0 63 60"
          fill="none"
          {...props}
        >
          <Path
            d="M47.0781 43.4808C48.5777 42.6273 49.793 40.5065 49.793 38.7737L49.793 16.5831C49.793 14.8503 48.5777 12.7554 47.0781 11.876L27.8672 0.780737C26.3676 -0.072747 23.9371 -0.0727472 22.4375 0.780737L3.22659 11.876C1.72695 12.7295 0.511722 14.8503 0.511722 16.5831L0.511721 38.7737C0.511721 40.5065 1.72695 42.6015 3.22659 43.4808L22.4375 54.5761C23.9371 55.4296 26.3676 55.4296 27.8672 54.5761L47.0781 43.4808Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Rect
            x="28.1602"
            y="1.51953"
            width="34.7031"
            height="58.3013"
            fill="url(#pattern0_1_39127)"
          />
          <Defs>
            <Pattern
              id="pattern0_1_39127"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1_39127"
                transform="matrix(0.003861 0 0 0.00229822 0 -0.00445854)"
              />
            </Pattern>
            <Image
              id="image0_1_39127"
              width="259"
              height="439"
              preserveAspectRatio="none"
              xlinkHref={beePracticeBotIcon}
            />
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { BeePracticeBotsHexagon };
